export const SPACE_LIST = {
    kb_1: 1024,
    mb_100: 104857600,
    gb_1: 1073741824,
    gb_2: 2147483648,
    gb_4: 4294967296,
    gb_8: 8589934592,
    gb_9: 9663676416,
    gb_16: 17179869184,
    gb_25: 26843545600,
    gb_32: 34359738368,
    gb_64: 68719476736,
    gb_128: 137438953472,
    gb_256: 274877906944,
    gb_512: 549755813888,
    tb_1: 1099511627776,
    tb_2: 2199023255552,
    tb_3: 3298534883328,
    tb_4: 4398046511104,
    tb_5: 5497558138880,
    tb_10: 10995116277760,
    tb_11: 12094627905536,
} as const;

export type SpaceListKeys = keyof typeof SPACE_LIST;
export type SpaceListValues = (typeof SPACE_LIST)[SpaceListKeys];
